import React, { FC } from 'react'

// Components
import { OrderedBreadcrumbs } from '@sketch/components'

// Styles
import { BreadcrumbsWrapper } from './SignUpBreadcrumbs.styles'

// Constants
const SIGN_UP_CRUMBS = [{ content: 'Create Account' }, { content: 'About You' }]
const WORKSPACE_CRUMBS = [...SIGN_UP_CRUMBS, { content: 'Create Workspace' }]

// Types
interface SignUpBreadcrumbsProps {
  showWorkspaceCrumbs: boolean
  currentCrumb: number
}

const SignUpBreadcrumbs: FC<SignUpBreadcrumbsProps> = ({
  showWorkspaceCrumbs,
  currentCrumb,
}) => (
  <BreadcrumbsWrapper>
    <OrderedBreadcrumbs
      crumbs={showWorkspaceCrumbs ? WORKSPACE_CRUMBS : SIGN_UP_CRUMBS}
      currentCrumb={currentCrumb}
    />
  </BreadcrumbsWrapper>
)

export default SignUpBreadcrumbs
